import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
  type TAbTestKey,
} from 'constants/ab-tests'
import { Cohort, GrowthbookKey } from 'root-constants'

const toKeysArray = (
  keys: TAbTestKey | TAbTestKey[] | undefined,
): TAbTestKey[] => {
  if (!keys) return []
  return Array.isArray(keys) ? keys : [keys]
}

export const getFilteredCohortAbTestKeys = (
  cohort: Cohort | string,
  country?: string,
): TAbTestKey[] => {
  const keys = [
    ...toKeysArray(COHORT_FIREBASE_KEYS_MAP[cohort as Cohort]),
    ...toKeysArray(COHORT_GROWTHBOOK_KEYS_MAP[cohort as Cohort]),
  ]

  if (!keys.length) return []

  const isIntl2 = cohort === Cohort.INTL_2

  const excludedKeys: TAbTestKey[] = [
    ...(isIntl2 && country !== 'GB'
      ? [GrowthbookKey.ABTEST_WEB_238_GBP_PRICING]
      : []),
  ]

  if (!excludedKeys.length) return keys

  return keys.filter((key) => !excludedKeys.includes(key))
}
